$ = require 'jquery'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
EmojiCompleterView = require 'app/scripts/views/internal/autocomplete/emoji-completer-view'
hasSelectionIn = require 'app/scripts/lib/util/selection/has-selection-in'
{ getKey, isForceSubmitEvent, Key } = require '@trello/keybindings'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
formatNumber = require 'app/scripts/lib/format/number'

module.exports = class EditableView extends View
  allowNewlines: true

  initialize: ->
    super

    # Initial work on this used effing f(@, 'saveDrafts', 'unload') as the callback for
    # unload, but this led to browsers showing a dialog for "you have unsaved
    # edit, are you sure you want to navigate away?" Having an anonymous callback
    # fixed the issue, so be careful changing this
    # This is most likely because that dialog will appear if the return value
    # is not null or undefined
    $(window).on "beforeunload.EditableView-#{@model.cid}", =>
      @saveDrafts('unload')
      return

  remove: ->
    # Save drafts seems to be called on reload of page but not when pressing the
    # back button on the page. So call it again here in case it hasn't
    @saveDrafts('removing view')
    $(window).off ".EditableView-#{@model.cid}"
    super

  _draftKey: (attr) -> "draft_#{ @model.id }_#{ attr }"
  _saveDraft: (attr, value) -> Storage.set(@_draftKey(attr), value)
  _recallDraft: (attr) -> Storage.get(@_draftKey(attr))
  _discardDraft: (attr) -> Storage.unset(@_draftKey(attr))

  saveDrafts: (invokeSource) ->
    return false if !@model.id?
    for $el in @getEdits()
      attr = $el.attr('attr')
      val = $el.find('.field:first').val()
      continue if $.trim(val).length == 0 # Not in edit mode
      if @model.get(attr) != val && val != @_recallDraft(attr)
        if invokeSource
          track('Editable View', 'Save Draft', "Save draft via #{invokeSource}")
          trackUe('Editable View', 'Save Draft', '', '', '', "when #{invokeSource}", '')
        @_saveDraft(attr, val)

  editField: (e) ->
    $link = $(e.target).closest('a')
    return if ($link.length > 0 && $link.attr('href') != '#')
    return if DragSort.sorting

    $container = $(e.target).closest('.editable')
    if $container.length == 0
      return

    # If they've selected some text, they're probably trying to copy it
    if hasSelectionIn($container)
      return

    Util.stop(e)
    PopOver.hide()

    attr = $container.attr('attr')

    @edit(attr)

  edit: (sAttr, focus = true) ->
    if sAttr.indexOf('.') > -1
      parts = sAttr.split('.')
      sAttr = parts[1]

    allEditableWithAttr = @$("[attr=#{sAttr}]")
    noEdits = @$(".js-no-higher-edits [attr=#{sAttr}]")
    container = allEditableWithAttr.not(noEdits)
    return if (container.length == 0)

    Layout.cancelEdits()
    edit = container.find('.edit:first')
    return if (edit.length == 0)

    input = container.find('.field:first')
    isTextArea = input.is('textarea')
    isCardDesc = input.parent().is('.card-detail-edit')
    current = container.find('.current')

    edit.append(templates.fill('edit_controls'))

    if (!edit.hasClass('delete'))
      edit.find('.delete').remove()
    if (!edit.hasClass('convert'))
      edit.find('.convert').remove()
    if (!edit.hasClass('options-menu'))
      edit.find('.options-menu').remove()
    if (!edit.hasClass('add-members'))
      edit.find('.add-members').remove()
    if (!edit.hasClass('assign'))
      edit.find('.assign').remove()
    if (!edit.hasClass('due'))
      edit.find('.due').remove()

    container.addClass('editing')

    if input.val() == ""
      input.val(Util.traverse(@model.attributes, parts ? sAttr))

    @waitForId @model, =>
      input.data('draftKey', @_draftKey(sAttr))

    log('editable', @model)

    if focus
      input.focus().select()
    input.autosize(append: false)
    return

  getEdits: ->
    $allEdits = @$('[attr]')
    # Make sure we don't process other editables that are nested
    # inside this one
    $noEdits = @$('.js-no-higher-edits [attr]')

    $allEdits.not($noEdits).map (index, el) => $(el)

  recallDrafts: ->
    @getEdits().each (i, $el) =>
      attr = $el.attr('attr')
      if @model.id?
        draftVal = @_recallDraft(attr)
        if draftVal?
          $input = $el.find('.field:first')
          $input.val(draftVal)
          @defer =>
            $el.find('.edits-warning').show()

  stopEditing: (e) ->
    Util.stop(e)
    Layout.cancelEdits()
    false

  clearEdits: (e) ->
    Util.stop(e)
    $editable = $(e.target).closest('.editable[attr]')
    attr = $editable.attr('attr')
    if attr?
      @_discardDraft(attr)
    $editable.find('.field').val("")
    $editable.find('.edits-warning').hide()
    $editable.find('.edits-error').hide()
    $editable.removeClass('editing')
    Layout.cancelEdits()
    false

  validate: ->
    for field in @$('.editing.non-empty .field')
      if /^\s*$/.test($(field).val())
        return false

    for field in @$('.editing .field')
      fieldLength = ($(field).val() ? '').length
      if fieldLength > 16384
        $('.editing')
        .find '.edits-error'
        .text l('text too long', { over: formatNumber(fieldLength - 16384) })
        .show()
        return false

    true

  keydownEvent: (e) ->
    key = getKey(e)

    if Layout.isEditing()

      if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
        @checkInsert?(e)

      else if isForceSubmitEvent(e) or ((key == Key.Enter && (!$(e.target).is("textarea") || $(e.currentTarget).hasClass('single-line'))) and !e.shiftKey)
        Util.stop(e)
        @commitEdits(e)

      else if key == Key.Enter && !@allowNewlines
        Util.stop(e)

    return

  commitEdits: (e, $customEditable = null) ->
    Util.stop(e) if e

    $editable = $customEditable || $(e.target).closest('.editable.editing[attr]')
    $editable.find('.edits-error').hide()

    if !@validate()
      return

    view = @
    model = @model
    customSet = @customSet

    # Remove buttons
    $editable.remove('input[type=submit]')

    # Remove buttons and commit all other edits
    $editable
    .removeClass('editing')
    .each(->
      attr = $(this).attr('attr')
      newValue = $(this).find('.field').val()

      if !view.allowNewlines
        newValue = newValue.replace(/[\r\n]+/g, ' ')

      # if the newValue is all whitespace, replace it with the empty string
      if $.trim(newValue).length == 0
        newValue = ""

      if model.get(attr) == newValue
        view._discardDraft(attr)
      else
        model.update attr, newValue, (err) ->
          if err?
            $editable.find('.edits-error').text(err.message).show()
          else
            view._discardDraft(attr)
          return
    )
    .find('.field').val("")

    $editable.find('.edits-warning').hide()

    true

  clickSetting: (e) ->
    $target = $(e.target)
    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    # If this is an actual link, let it through
    href = $target.attr('href')
    if href && href != '#'
      return

    prefName = $target.closest('.pref').attr('name')
    if !prefName
      return
    setting = $target.attr('value')

    setting =
      switch setting
        when 'true' then true
        when 'false' then false
        else setting

    @model.setPref(prefName, setting)
    @model.save()

    Util.stop(e)
    return

  delegateEvents: (events) ->
    editableEvents =
      'click .current': 'editField'
      'click .js-cancel-edit': 'clearEdits'
      'click .js-discard-edits': 'clearEdits'
      'click .js-view-edits': 'editField'
      'click .js-save-edit': 'commitEdits'
      'keydown .field': 'keydownEvent'
      'click input': Util.stopPropagation
      'click textarea': Util.stopPropagation

    if @model.setPref?
      editableEvents['click a'] = 'clickSetting'

    super(_.extend(editableEvents, events || @events))
